import "./ProviderCard.css";
import {
  
  FaStar,
  FaMapMarkerAlt,
  FaUtensils,
  FaStore,
  FaBirthdayCake,
  FaHome,
  FaConciergeBell,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import getImageUrl from "../../../utils/imageUrl";
function ProviderCard({ provider }) {
  const navigate = useNavigate();

  const getProviderIcon = (type) => {
    switch (type?.toLowerCase()) {
      case "restaurant":
        return <FaUtensils />;

      case "provision store":
        return <FaStore />;

      case "bakery":
        return <FaBirthdayCake />;

      case "home kitchen":
      case "home chef":
        return <FaHome />;

      case "catering":
        return <FaConciergeBell />;

      default:
        return <FaStore />;
    }
  };

  const imageUrl = getImageUrl(provider.image);

  const isOpen =
    provider.businessStatus?.toLowerCase() === "open";

  return (
    <div
      className="provider-card"
     onClick={() =>
  navigate(
    `/provider/${
      provider.providerId ||
      provider._id ||
      provider.id
    }`
  )
}
    >
      {/* Banner Image */}

      <div className="provider-image">

        <img
          src={imageUrl}
          alt={provider.businessName}
          onError={(e) => {
            e.target.src = "/images/food-placeholder.jpg";
          }}
        />

        

      </div>

      {/* Card Content */}

      <div className="provider-content">

        {/* Business Name + Status */}

        <div className="provider-title-row">

          <h3>{provider.businessName}</h3>

          <div
            className={`provider-status ${
              isOpen ? "open" : "closed"
            }`}
          >
            <span className="status-dot"></span>

            {isOpen ? "Open" : "Closed"}
          </div>

        </div>

        {/* Provider Type + Rating */}

        <div className="provider-top">

          <div className="provider-type">

            {getProviderIcon(provider.providerType)}

            <span>{provider.providerType}</span>

          </div>

          <div className="provider-rating">

            <FaStar />

            <span>
              {Number(provider.rating || 0).toFixed(1)}
            </span>

          </div>

        </div>

        <div className="divider"></div>

        {/* Food Preview */}

        <div className="provider-foods">

          {provider.items?.length
            ? provider.items
                .slice(0, 3)
                .join(" • ")
            : "Meals • Snacks • Special Items"}

        </div>

        {/* Location */}

        <div className="provider-location">

          <FaMapMarkerAlt />

          <span>

            {provider.area || "Location"}

            {provider.city && `, ${provider.city}`}

          </span>

        </div>

      </div>

    </div>
  );
}

export default ProviderCard;